import { ReactNode } from "react";

interface FloatingButtonProps {
  onClick?: () => void;
  children?: ReactNode;
}

export default function FloatingButton({
  onClick,
  children,
}: FloatingButtonProps) {
  return (
    <button
      onClick={onClick}
      // fixed는 뷰포트 기준 — 데스크톱(md)은 중앙 카드(480px) 안쪽 우하단으로 보정
      className="fixed bottom-24 right-6 z-50 w-14 h-14 rounded-full bg-[#25C6DA] shadow-lg flex items-center justify-center md:right-[calc(50%-216px)] md:bottom-32"
      style={{ boxShadow: "0 4px 12px rgba(0,0,0,0.15)" }}
    >
      {children}
    </button>
  );
}
